import { useEffect } from 'react';
import { getSEOForPath } from './seo';
import { trackPageView } from './analytics';

const upsertMeta = (attr: 'name' | 'property', key: string, content: string) => {
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

const upsertCanonical = (href: string) => {
  let link = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

export const useSEO = (path: string) => {
  useEffect(() => {
    const seo = getSEOForPath(path);

    document.title = seo.title;
    upsertMeta('name', 'description', seo.description);
    upsertMeta('name', 'keywords', seo.keywords.join(', '));
    upsertMeta('name', 'robots', seo.robots ?? 'index,follow');

    upsertMeta('property', 'og:title', seo.title);
    upsertMeta('property', 'og:description', seo.description);
    upsertMeta('property', 'og:type', seo.type ?? 'website');
    upsertMeta('property', 'og:url', seo.url ?? window.location.href);
    upsertMeta('property', 'og:site_name', 'TinyWins.ai');
    upsertMeta('property', 'og:image', seo.image ?? '');

    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', seo.title);
    upsertMeta('name', 'twitter:description', seo.description);
    upsertMeta('name', 'twitter:image', seo.image ?? '');

    upsertCanonical(seo.url ?? window.location.href);
    trackPageView(path, seo.title);
  }, [path]);
};
